export const adacTranslations = {
  de: {
    policyOverview: {
      title: 'ADAC Zuhause-Schutzbrief',
      close: 'Schließen',
      overview: 'Übersicht',
      imageAlt: 'Ausgelaufene Waschmaschine in einer überfluteten Küche',
      description:
        'Ausgesperrt? Rohr verstopft? Heizung streikt? Der ADAC Zuhause-Schutzbrief organisiert schnell und passende Hilfe, wenn Zuhause etwas schiefgeht!',
      customerNumber: 'Deine Kundennummer',
      confirmationNumber: 'Deine Versicherungs\u00ADbestätigungs-Nummer',
      personalDetails: 'Deine Daten',
      dateOfBirth: 'geb. {date}',
      edit: 'ändern',
      editLabel: 'Deine Daten ändern',
      emergencyContact: 'Kontaktdaten für den Notfall',
      emergencyAvailability: 'Schadendirektruf rund um die Uhr erreichbar',
      customerService: 'Kundenservice Mo.–Fr. 9–19 Uhr',
      documents: 'Dokumente',
      document: {
        confirmation: 'Versicherungsbestätigung',
        conditions: 'Versicherungsbedingungen',
        privacyNotice: 'Datenschutzhinweise',
        insuredPersonInformation: 'Information für versicherte Personen',
        productInformation: 'Produktinformationsblatt',
      },
      call: 'Jetzt anrufen: {phoneNumber}',
    },
  },
  en: {
    policyOverview: {
      title: 'ADAC Home Protection',
      close: 'Close',
      overview: 'Overview',
      imageAlt: 'Leaking washing machine in a flooded kitchen',
      description:
        'Locked out? Blocked pipe? Heating broken? ADAC Home Protection quickly arranges suitable help when something goes wrong at home!',
      customerNumber: 'Your customer number',
      confirmationNumber: 'Your insurance confirmation number',
      personalDetails: 'Your details',
      dateOfBirth: 'Born {date}',
      edit: 'Edit',
      editLabel: 'Edit your details',
      emergencyContact: 'Emergency contact details',
      emergencyAvailability: 'Claims hotline available around the clock',
      customerService: 'Customer service Mon–Fri, 9 am–7 pm',
      documents: 'Documents',
      document: {
        confirmation: 'Insurance confirmation',
        conditions: 'Insurance terms and conditions',
        privacyNotice: 'Privacy notice',
        insuredPersonInformation: 'Information for insured persons',
        productInformation: 'Product information sheet',
      },
      call: 'Call now: {phoneNumber}',
    },
  },
};
